export const PORTAL_FLEETS_KEY = 'ago.portalFleets';

export function fleetCodeList(fleet) {
  if (fleet == null || fleet === false || fleet === '') return '';
  return Array.isArray(fleet)
    ? fleet.filter(Boolean).join(',')
    : String(fleet).trim();
}

export function rememberFleets(fleet) {
  const code = fleetCodeList(fleet);
  if (!code) return;
  try {
    sessionStorage.setItem(PORTAL_FLEETS_KEY, code);
  } catch (e) {
    // Private mode can reject storage. The URL still carries the fleet.
  }
}

export function recalledFleets() {
  try {
    return sessionStorage.getItem(PORTAL_FLEETS_KEY) || '';
  } catch (e) {
    return '';
  }
}

export function withFleets(path, fleet) {
  const code = fleetCodeList(fleet);
  if (!code) return path;
  const join = path.includes('?') ? '&' : '?';
  return `${path}${join}fleets=${encodeURIComponent(code)}`;
}

const FLEET_REQUIRED_EXACT = [
  '/personal-insurance-review',
  '/reservation-cancel-close-review',
];

const FLEET_AGNOSTIC_EXACT = [
  '/combine-accounts',
];

/** 'required' restores ?fleets=. 'agnostic' drops it. 'optional' leaves the URL alone. */
export function fleetRouteKind(pathname) {
  const path = pathname || '/';
  if (path === '/admin' || path.startsWith('/admin/') || FLEET_AGNOSTIC_EXACT.includes(path)) {
    return 'agnostic';
  }
  if (FLEET_REQUIRED_EXACT.includes(path)) return 'required';
  if (
    path.startsWith('/user/') ||
    path.startsWith('/userpersonalinsurancedoc/') ||
    path.startsWith('/reservation/') ||
    path.startsWith('/vehicle/')
  ) {
    return 'required';
  }
  return 'optional';
}

export function pathWritesFleetQuery(pathname) {
  return fleetRouteKind(pathname) !== 'agnostic';
}

/**
 * What the shell should do with ?fleets= on this location.
 * search === null means leave the URL alone. search === '' means drop the query.
 * remember/selected are fleet code lists to store, or null to leave storage/state alone.
 */
export function fleetQueryAction({ pathname, search, selectedFleets, recalled }) {
  const params = new URLSearchParams(search || '');
  const kind = fleetRouteKind(pathname);
  const fromUrl = (params.get('fleets') || '').split(',').filter(Boolean);

  if (params.has('fleets') && kind === 'agnostic') {
    params.delete('fleets');
    return {
      remember: fromUrl.length ? fromUrl : null,
      selected: fromUrl.length ? fromUrl : null,
      search: params.toString(),
    };
  }

  if (fromUrl.length) {
    return { remember: fromUrl, selected: fromUrl, search: null };
  }

  if (kind === 'required') {
    const fromState = Array.isArray(selectedFleets)
      ? selectedFleets.filter(Boolean).join(',')
      : '';
    const remembered = fromState || recalled || '';
    if (remembered) {
      params.set('fleets', remembered);
      return { remember: null, selected: null, search: params.toString() };
    }
  }

  return { remember: null, selected: null, search: null };
}
